import React from 'react';
import { connect } from 'react-redux';
import classes from './BaggageSelect.scss';
import Checkbox from '../../../UI/CommonCheckBox/CommonCheckBox';

import baggage5kgImage from './img/bag-5kg.svg';
import baggage10kgImage from './img/bag-10kg.svg';
import baggage15kgImage from './img/bag-15kg.svg';
import baggage20kgImage from './img/bag-20kg.svg';
import baggage30kgImage from './img/bag-30kg.svg';

import * as farePriceActions from '../../../../store/actions/index';

const baggageSelect = (props) => {
    let baggageViewO = props.baggageViewO;
    let baggageViewR = props.baggageViewR;
    let baggageView = null;
    let rph = null;
    let uid = null;
    let tripType = null;
    let baggageImage = null;
    let selectedBaggage = {};
    if (props.flow === 'O') {
        baggageViewO = props.baggage.O[baggageViewO].baggageOptions;
        rph = props.baggage.O[props.baggageViewO].rph;
        uid = props.baggage.O[props.baggageViewO].uid;
        baggageView = baggageViewO;
        tripType = props.flow;
        if(Object.keys(props.selectedBaggage.O).length !== 0) {
            selectedBaggage = props.selectedBaggage.O[props.baggageViewO];
        }
    } else {
        baggageViewR = props.baggage.R[baggageViewR].baggageOptions;
        rph = props.baggage.R[props.baggageViewR].rph;
        uid = props.baggage.R[props.baggageViewR].uid;
        baggageView = baggageViewR;
        tripType = props.flow;
        if(Object.keys(props.selectedBaggage.R).length !== 0) {
            selectedBaggage = props.selectedBaggage.R[props.baggageViewR];
        }
    }

    return (
        <ul className={classes.List}>
            {baggageView.map(baggage => {
                    if(baggage.desc.toLowerCase().replace(/ +/g, "") === "5kg" || baggage.desc.toLowerCase().replace(/ +/g, "") === "3kg" || baggage.desc.toLowerCase().replace(/ +/g, "") === "free") {
                        baggageImage = baggage5kgImage;
                    } else if (baggage.desc.toLowerCase().replace(/ +/g, "") === "10kg") {
                        baggageImage = baggage10kgImage;
                    } else if(baggage.desc.toLowerCase().replace(/ +/g, "") === "15kg") {
                        baggageImage = baggage15kgImage;
                    } else if(baggage.desc.toLowerCase().replace(/ +/g, "") === "20kg") {
                        baggageImage = baggage20kgImage;
                    } else if(baggage.desc.toLowerCase().replace(/ +/g, "") === "30kg") {
                        baggageImage = baggage30kgImage;
                    }
                    return <li className={[classes.ListItem, selectedBaggage ? selectedBaggage.typ === baggage.typ ? classes.ListItemActive : null : null].join(' ')} key={baggage.typ} onClick={props.passengers.length === 1 ? 
                        () => {
                            if(selectedBaggage.desc === baggage.desc) {
                                props.onSaveBaggage(baggage, rph, uid, tripType);
                                props.onDeselctBaggage(props.passengers[0].paxID, props.flow);
                                props.onRemoveAddon("Baggage", parseInt(baggage.amt, 10), props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex, props.flow === 'O' ? 'O' : 'R');
                            } else {
                                props.onRemoveAddon("Baggage", parseInt(selectedBaggage.amt, 10), props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex, props.flow === 'O' ? 'O' : 'R');
                                props.onSaveBaggage(baggage, rph, uid, tripType);
                                props.onSelectBaggage(props.passengers[0].paxID, props.flow, props.passengers[0].ssrDetails.ssrBaggageDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex].desc === selectedBaggage.desc);
                                baggage.amt !== '0' ? props.onAddAddon({addonLabel: "Baggage", amount: parseInt(baggage.amt, 10), legIndex: props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex, leg: props.flow === 'O' ? 'O' : 'R'}) : console.log("Amount greater that zero");
                            }
                        } :
                        () => {
                            props.onSaveBaggage(baggage, rph, uid, tripType);
                            props.onShowPax();
                        }}>
                        <div className="mr-3 u-size40x40 u-flex align-items-center justify-content-center">
                            <img src={baggageImage} alt={baggage.desc} />
                        </div>
                        <div className={`u-flex mr-auto`}>
                            <div className={`u-flex align-items-start f-column justify-content-center`}>
                                <p className="u-fontSize13 u-textColorLight">Additional</p>

                                <p className={`u-fontSize16 u-textColorDark`}>{baggage.desc}</p>
                            </div>
                        </div>
                        <div className="u-flex">
                            <div className="u-flex align-items-start f-column justify-content-center align-items-end mr-6">
                                <p className="u-fontSize13 u-textColorLight">per person</p>
                                <p className="u-fontSize16 u-textColorDark">&#8377; {baggage.amt}</p>
                            </div>
                        </div>
                        {props.passengers.length === 1 ? (
                            <Checkbox 
                                type="ssr" 
                                readOnly 
                                checked={selectedBaggage ? selectedBaggage.typ === baggage.typ && props.passengers[0].ssrDetails.ssrBaggageDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex].desc !== "" ? true : false : false}
                                />
                        ) : (
                            <Checkbox 
                                type="ssr" 
                                readOnly 
                                checked={selectedBaggage ? selectedBaggage.typ === baggage.typ ? true : false : false}
                                />
                        )}
                    </li>
                })}
        </ul>
    );
}

const mapStateToProps = state => {
    return {
        passengers: state.farePrice.passengers,
        baggageViewOIndex: state.farePrice.baggageViewOneWayVal,
        baggageViewRIndex: state.farePrice.baggageViewReturnVal,
        selectedBaggage: state.farePrice.selectedBaggage
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSaveBaggage: (baggage, rph, uid, tripType) => dispatch(farePriceActions.saveBaggage(baggage, rph, uid, tripType)),
        onSelectBaggage: (id, flow, isUpdate) => dispatch(farePriceActions.selectBaggageSSR(id, flow, isUpdate)),
        onDeselctBaggage: (id, flow) => dispatch(farePriceActions.deselectBaggage(id, flow)),
        onShowPax: () => dispatch(farePriceActions.showPax()),
        onAddAddon: (addon) => dispatch(farePriceActions.addAddon(addon)),
        onRemoveAddon: (label, amount, legIndex, leg) => dispatch(farePriceActions.removeAddon(label, amount, legIndex, leg))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(baggageSelect);



// WEBPACK FOOTER //
// ./src/components/Addons/Baggage/BaggageSelect/BaggageSelect.js